import React from "react";

export const getItemCodes = (item, activeTab) => {
  const codeString = getItemCode(item, activeTab);
  if (!codeString) return [];

  if (activeTab === "ACHI Tabular" || activeTab === "ACHI Index") {
    return [codeString];
  }

  // Split ICD codes only at delimiters outside square brackets.
  const delimiter = /[\u2020* ,]+(?![^[]*\])/;
  return codeString.split(delimiter).filter((code) => code.trim() !== "");
};

const getItemCode = (item, activeTab) => {
  switch (activeTab) {
    case "ICD 10 AM Index":
    case "ACHI Index":
      return item.description;
    case "ICD 10 AM Tabular":
    case "ACHI Tabular":
    case "Australian Coding Standard":
    default:
      return item.name;
  }
};

export const highlightText = (text, query, onChangeCodeBook = false) => {
  if (!query || query.length < 2 || !text) return text;

  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = onChangeCodeBook
    ? new RegExp(escapedQuery, "i")
    : new RegExp(`^${escapedQuery}$`);

  return regex.test(text) ? <span className="highlighted">{text}</span> : text;
};

export const handleDragStartLogic = (event, draggableCodes, activeTab) => {
  if (!draggableCodes.length) {
    event.preventDefault();
    return;
  }

  const serializedCodes = JSON.stringify(draggableCodes);
  const dragData = { codes: draggableCodes, tab: activeTab };
  event.dataTransfer.setData("application/json", JSON.stringify(dragData));
  event.dataTransfer.setData("text/plain", serializedCodes);
  event.dataTransfer.setData(
    "text/uri-list",
    `data:text/plain;charset=utf-8,${encodeURIComponent(serializedCodes)}`,
  );
};
